export const valuesCategory = [
  "Taxas locais do destino",
  "Taxas locais da origem",
  "Frete e taxas que acompanham frete",
  "Outras taxas"
];

export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  BRL = 'BRL',
  GBP = 'GBP',
  JPY = 'JPY',
  AUD = 'AUD',
  CAD = 'CAD',
  CHF = 'CHF',
  CNY = 'CNY',
  SEK = 'SEK',
  NZD = 'NZD'
}